"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIconBubbleLink = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _button = require("../../../styles/2_commonComponentStyles/button");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledIconBubbleLink = _styledComponents.default.a.withConfig({
  displayName: "IconBubbleLinkstyles__StyledIconBubbleLink",
  componentId: "zhkeg0-0"
})(["", " ", " ", " ", " &,& *{text-decoration:none;}"], _button.clickable, _button.baseButton, _button.buttonThemes, _button.iconBubble);

exports.StyledIconBubbleLink = StyledIconBubbleLink;